module.exports = "<div [class]=\"animationShapeRight ? 'animationnew-shap' : 'animation-shap'\">\r\n  <div class=\"shap-bg\"></div>\r\n</div>\r\n"